import { values } from 'lodash';

import { SchemaField } from '../../../../../../generic/serialization/schema-field';
import { SerializableObjectSchema } from '../../../../../../generic/serialization/serializable-object-schema';
import { ReservationSkipOffersIfRuleName } from '../reservation-skip-offers-if-rule-name';

export abstract class ReservationSkipOffersIfRuleSchema extends SerializableObjectSchema {
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // The name of the command
  public static readonly type = 'type';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Defaults
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly type = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = {} as any;

    /* eslint-disable */
    parameters[ReservationSkipOffersIfRuleSchema.type] = SchemaField.string(
      ReservationSkipOffersIfRuleSchema.type,
      ReservationSkipOffersIfRuleSchema.Defaults.type,
    ).valid(...values(ReservationSkipOffersIfRuleName));
    /* eslint-enable */

    return parameters;
  }
}
